import { useContext } from 'react'
import UserContext, { Roles } from '../../UserContext'
import { Link } from '@reach/router'
import NotificationBell from './NotificationBell'
import { TrackedButton } from './AnalyticsEvents'

type PageHeadingProps = {
    pageTitle: string
    createButton: false | JSX.Element
    filterButton: false | JSX.Element
    filterCount?: number
}

const PageHeading: React.FC<PageHeadingProps> = ({ pageTitle, createButton, filterButton, filterCount }) => {
    const userContext = useContext(UserContext)

    const configData = window.CS_CONFIG

    function getName() {
        return userContext.user.providerName === null || userContext.user.providerName === undefined || userContext.user.providerName.trim().length === 0
            ? userContext.user?.name
            : `${userContext.user.name ?? ''} - ${userContext.user?.providerName}`;
    }

    return (
        <>
            <div className="article-header grid-content grid-x">
                <div className="large-3 page-title">
                    <h2>{pageTitle}</h2>
                </div>
                <div className="large-5 page-custom-section">
                    {createButton !== false && <p>{createButton}</p>}
                    {filterButton !== false && <p className='filter-button'>{filterButton} {filterCount ? <span className="filter-count-badge">{filterCount}</span> : null}</p>}
                </div>
                <div className="large-4 user-info">
                    <p className='user-info-banner'>
                        <NotificationBell />
                        <span>Welcome back, <span className="name">{getName()}</span>.</span>
                        <i className="far fa-caret-circle-down"></i>
                    </p>
                    <div className="user-info-detail">
                        <ul>
                            <li>{userContext.roles.map((x, i) => <span className="role" key={i}>{x}</span>)}<i className="fas fa-user-tag"></i></li>
                            <hr />
                            {(!!userContext.token && userContext.hasAnyRole(Roles.Impersonator)) && <><li><TrackedButton event='Nav_Impersonation'><Link to="/fake-sso">Impersonation</Link></TrackedButton><i className="fas fa-portrait"></i></li></>}
                            <li><TrackedButton event='Nav_ReturnToProviderPortal'><a href={configData.ProviderPortalLink} title='Provider Portal'>Return to Provider Portal</a></TrackedButton><i className="fas fa-sign-out-alt"></i></li>
                            <li><TrackedButton event='Nav_Logout'><Link to="/logout">Logout</Link></TrackedButton><i className="fas fa-sign-out-alt"></i></li>
                            {userContext.hasAnyRole(Roles.Provider, Roles.WaiverServiceCoordinator, Roles.WaiverServiceLeader, Roles.MarketAdmin) && <li><TrackedButton event='Nav_UserPreferences'><Link to="/preferences">User Preferences</Link></TrackedButton><i className="far fa-sliders-h"></i></li>}
                            {userContext.hasAnyRole(Roles.ITSupport) && <li><TrackedButton event='Nav_GuidingCareAdmin'><Link to="/admin/guidingcare-replica">GuidingCare Admin</Link></TrackedButton><i className="far fa-tools"></i></li>}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageHeading